import { UserRoles } from '@backend/models/types/user';

export interface RoleAccessFlags {
  isAdmin: boolean;
  isManager: boolean;
  isAdminOrManager: boolean;
}

export const deriveRoleAccess = (
  roles: UserRoles[] = []
): RoleAccessFlags => {
  const isAdmin = roles.includes(UserRoles.Admin);
  const isManager = roles.includes(UserRoles.Manager);

  return {
    isAdmin,
    isManager,
    isAdminOrManager: isAdmin || isManager
  };
};
